import axios from 'axios'
import Qs from 'qs'
import status from './error'
import path from './path'

// Promise finally polyfill
if (!Promise.prototype.finally) {
  Promise.prototype.finally = callback => {
    let _self = this.constructor
    return this.then(
      data => _self.resolve(callback()).then(() => data),
      err => _self.resolve(callback()).then(() => { throw err })
    )
  }
}

// axios 简单封装
axios.defaults.retry = 3
axios.defaults.timeout = 1e4
axios.defaults.retryDelay = 1e3

// axios.defaults.baseURL =''

//http request 拦截器
axios.interceptors.request.use(
  config => {
    if (config.url == 'https://www.eyouglobal.com/api/job/fileUpload') {
      config.timeout = 6e4
    }
    Object.assign({
      'Content-Type': 'application/x-www-form-urlencoded'
    }, config.headers)

    return config
  }
)

//http response 拦截器
axios.interceptors.response.use(
  response => {
    // 请求数据返回
    let data = response.data
    if (typeof data == 'string' && /\{|\}/.test(data)) {
      response.data = JSON.parse(data)
    }
    if (data.code !== 200) {
      // return $message(data.message)
      return false
    }
    return Promise.resolve(response.data)
  },
  error => {
    // 连接状态返回
    if (error) {
      let err = undefined

      if (error.response) err = status[err.response.status || 'default']
      else err = error.toString()
      alert(err)

    }
  }
)



/**
* ajax方法
* @param url
* @param params
* @param method
* @param config axios的配置项，可定义请求头信息等
* @return {Promise}
*/

const Ajax = (url, params, method, config) => {

  let ajax = new Promise((resolve, reject) => {

    let cfg = {
      url,
      method
    }

    if (method === 'post') {
      if (params instanceof FormData) {
        cfg.data = params
      } else {
        cfg.data = Qs.stringify(params)
      }
    } else {
      cfg.params = params
    }

    if (typeof (config) == 'object') {
      Object.assign(cfg, config)
    }

    // ajax加上loading
    const loading = $loading()
    axios.request(cfg).then(response => {
      loading.hide()
      resolve(response)
    }).catch(error => {
      loading.hide()
      reject(error)
    })
  })

  ajax.always = (callback = new Function) => {
    this.finally(response => {
      callback && callback(response)
    })
  }

  return ajax
}

window.$ = {
  path,
  get(url, params = {}, config) {
    return Ajax(url, params, 'get', config)
  },
  post(url, params = {}, config) {
    return Ajax(url, params, 'post', config)
  },

  // 加载脚本
  getScript(url, callback) {

    return new Promise(resolve => {

      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = 'async'
      script.src = url


      script.addEventListener('load', () => {
        resolve()
        typeof (callback) == 'function' && callback()
      }, false)

      script.addEventListener('error', () => {
        console.error(`Script:[${url}] load fail.`)
      }, false)

      document.head.appendChild(script)

    })

  }
}